import BaseAbility from 'umg-ember-backend/abilities/base';

export default class CustomShopAbility extends BaseAbility {
  get permissions() {
    return this.permission.for('product');
  }
}
